// extracted by mini-css-extract-plugin
export default {"title":"o5o_jH0gjA8zSJfV72bP","nextButton":"EMYvLG_tyJmdsCQVtrjD","details":"yy35R9oCI9K4tYanfOAD","buttonLoader":"HxZgyNblE14OgKTGC7fu"};